// assets/mc-bundles.js
(function () {
  let adding = false;

  // =========================
  // MC BUNDLE SETTINGS
  // Set to "cart" or "checkout"
  // =========================
  const MC_BUNDLE_REDIRECT = "cart"; // <-- change to "checkout" when you want

  // Robust parsing:
  // Supports: "123,456", "123 456", "123|456", "123;456", and JSON arrays like ["123","456"] or [123,456]
  function parseIds(str) {
    const s = (str || "").trim();
    if (!s) return [];

    // JSON array support
    if (s.startsWith("[") && s.endsWith("]")) {
      try {
        const arr = JSON.parse(s);
        if (Array.isArray(arr)) {
          return arr
            .map((x) => Number(String(x).trim()))
            .filter((n) => Number.isFinite(n) && n > 0);
        }
      } catch (e) {
        // fall through to delimiter parsing
      }
    }

    // Delimiter support
    return s
      .split(/[\s,;|]+/)
      .map((t) => Number(t.trim()))
      .filter((n) => Number.isFinite(n) && n > 0);
  }

  async function addBundle(ids) {
    if (!ids.length) return false;

    const items = ids.map((id) => ({ id, quantity: 1 }));

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      try {
        console.error("Bundle add failed:", await res.json());
      } catch (_) {}
      return false;
    }
    return true;
  }

  document.addEventListener(
    "click",
    async function (evt) {
      // Only hijack normal left-clicks (so open-in-new-tab still works)
      if (evt.defaultPrevented) return;
      if (evt.button !== 0) return;
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;

      // Only hijack clicks on actual links (title/image),
      // not random whitespace inside the card
      const link = evt.target.closest("a");
      if (!link) return;

      // Don't hijack quick add / buttons / forms / modal openers
      if (
        evt.target.closest(
          "form, button, .quick-add, .product-form, modal-opener, quick-add-modal"
        )
      )
        return;

      // Find bundle wrapper with data-bundle-ids
      const el = evt.target.closest("[data-bundle-ids]");
      if (!el) return;

      const ids = parseIds(el.getAttribute("data-bundle-ids"));
      if (!ids.length) return; // let normal navigation happen

      evt.preventDefault();
      if (adding) return;
      adding = true;

      try {
        const ok = await addBundle(ids);

        if (!ok) {
          // fallback: go to product page
          window.location.href = link.href;
          return;
        }

        // Redirect based on toggle:
        window.location.href =
          MC_BUNDLE_REDIRECT === "checkout" ? "/checkout" : "/cart";
      } catch (e) {
        console.error(e);
        window.location.href = link.href;
      } finally {
        adding = false;
      }
    },
    true
  );

 /* ============================================================
   ===== MC BOOK PAGES — TRACKING BLOCK: START =====
   Interaction tracking -> dataLayer -> GTM (GTM-PT9Q66H9) -> GA4
   Fires: book_watch, book_download, book_copy_link, book_scroll
   Also performs the actual file download + copy-link actions.
   Delegated on document; works on every current & future book page.
   Replaces the earlier "Download / Copy Link handlers (restored)" block.
   NOTE: when new books launch, add their video CDN hashes to SPEED_MAP.
   ============================================================ */
(function () {
  if (window.__mcBookTrackBound) return;   // guard against double-load
  window.__mcBookTrackBound = true;

  window.dataLayer = window.dataLayer || [];
  function push(obj) { window.dataLayer.push(obj); }

  // book title: from the Book JSON-LD "name", else document.title
  function bookTitle() {
    try {
      var all = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < all.length; i++) {
        var j = JSON.parse(all[i].textContent);
        if (j && j['@type'] === 'Book' && j.name) return j.name;
      }
    } catch (e) {}
    return document.title;
  }

  // map the three CDN video hashes -> friendly speed labels (extend per book)
  var SPEED_MAP = {
    'dfd1645a5af34ed5b05b7a3170e1e34b': 'Slower 0.8x',
    '9a86c1e45c6c404f83a41a2f9c3f2dcc': 'Medium 1.0x',
    '89b670e5293546a6b79916735c5c0edd': 'Faster 1.2x'
  };
  function speedFromUrl(url) {
    if (!url) return '';
    for (var hash in SPEED_MAP) { if (url.indexOf(hash) !== -1) return SPEED_MAP[hash]; }
    return '';
  }

  // ---- WATCH (anchor to a .mp4 that opens in a tab) ----
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="cdn.shopify.com/videos"]') : null;
    if (!a) return;
    var url = a.href;
    push({
      event: 'book_watch',
      book_title: bookTitle(),
      asset_label: speedFromUrl(url),
      asset_url: url
    });
  });

  // ---- DOWNLOAD: dataLayer push, then fetch -> blob save with friendly
  //      filename; fallback: open in new tab + show press-and-hold hint ----
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('button[data-dl]') : null;
    if (!btn) return;

    var url  = btn.getAttribute('data-dl');
    var name = btn.getAttribute('data-name') || 'read-along.mp4';
    if (!url) return;

    push({
      event: 'book_download',
      book_title: bookTitle(),
      asset_label: speedFromUrl(url) || name,
      asset_url: url,
      file_name: name
    });

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Saving…';

    function fallback() {
      // CORS or fetch failure: open the file directly and surface the hint
      window.open(url, '_blank', 'noopener');
      var hint = document.getElementById('bhap-dlhint');
      if (hint) hint.style.display = 'block';
    }

    function restore() {
      btn.disabled = false;
      btn.textContent = original;
    }

    fetch(url, { mode: 'cors' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.blob();
      })
      .then(function (blob) {
        var a = document.createElement('a');
        var objUrl = URL.createObjectURL(blob);
        a.href = objUrl;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () { URL.revokeObjectURL(objUrl); }, 60000);
        restore();
      })
      .catch(function () {
        restore();
        fallback();
      });
  });

  // ---- COPY LINK (book page button id="bhap-copy") ----
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('#bhap-copy') : null;
    if (!btn) return;

    var canonical = document.querySelector('link[rel="canonical"]');
    var url = (canonical && canonical.href) || (location.origin + location.pathname);
    var msg = document.getElementById('bhap-copied');

    push({ event: 'book_copy_link', book_title: bookTitle(), asset_url: url });

    function ok() {
      if (msg) {
        msg.textContent = 'Link copied!';
        setTimeout(function () { if (msg) msg.textContent = ''; }, 2500);
      }
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(ok, function () {
        window.prompt('Copy this link:', url);
      });
    } else {
      window.prompt('Copy this link:', url);
    }
  });

  // ---- SCROLL DEPTH (25/50/75/100), book pages only, once each ----
  if (/\/pages\/(uh-oh-my-backpack-ate-it|childrens-books)/.test(location.pathname) ||
      document.getElementById('bhap-landing')) {
    var hit = {};
    function onScroll() {
      var h = document.documentElement;
      var pct = (h.scrollTop + window.innerHeight) / h.scrollHeight * 100;
      [25, 50, 75, 100].forEach(function (mark) {
        if (pct >= mark && !hit[mark]) {
          hit[mark] = true;
          push({ event: 'book_scroll', book_title: bookTitle(), percent_scrolled: mark });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
/* ===== MC BOOK PAGES — TRACKING BLOCK: END ===== */
})();
